import { FC } from "react";
import { useTranslation } from "react-i18next";

import { AvgMaterialCompositionSmallHomeAppliancesTooltipProps } from "./AvgMaterialCompositionSmallHomeAppliancesTooltip.type";

const AvgMaterialCompositionSmallHomeAppliancesTooltip: FC<AvgMaterialCompositionSmallHomeAppliancesTooltipProps> = (props) => {
	const { t } = useTranslation();

	const { active, payload } = props;

	if (!active || !payload || !payload.length) {
		return null;
	}

	const data = payload[0] && payload[0].payload;

	return (
		<div className="p-3 m-0 bg-white border border-primary">
			<p className="text-xs">
				{t("pages.pillar.pillar1.averageMaterialCompositionOfSmallHomeAppliances.blocks.chart.tooltip", {
					material: props.material,
					value: new Intl.NumberFormat("nl-BE").format(data.value),
					category: t(`pages.pillar.pillar1.averageMaterialCompositionOfSmallHomeAppliances.blocks.chart.xAxisLabels.${data.category}`),
				})}
			</p>
		</div>
	);
};

export { AvgMaterialCompositionSmallHomeAppliancesTooltip };
